var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNordea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 136.1 28.3",
    style: {
      enableBackground: "new 0 0 136.1 28.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#164193"
    },
    d: "M124,6c-5.5,0.4-9.9,4.9-10.3,10.4c-0.4,6.5,4.7,11.9,11.1,11.9c2.3,0,5.4-1.2,6.8-3.6V28h4.3l0-10.6 C136.1,10.4,130.4,5.5,124,6z M131.3,17.5c-0.2,3.7-3.4,6.5-7.2,6c-2.9-0.4-5.2-2.7-5.6-5.6c-0.4-3.9,2.6-7.2,6.4-7.2 c3.4,0,6.2,2.7,6.4,6.1V17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#164193"
    },
    d: "M100.4,6c-5.9,0.2-10.9,4.7-10.9,11.3c0,6,4.9,11.1,11.2,11.1c4.4,0,8.7-2.6,10.4-6.9l-4.3-1.3 c-0.8,1.8-2.7,3.3-4.8,3.7c-3,0.6-5.8-1.3-6.9-3.3l16.7-4.6C111.2,11.6,107.5,5.8,100.4,6z M94.2,16.7c0-2.3,1.4-5,4.4-6.1 c3.4-1.3,6.4,0.4,7.7,2.8L94.2,16.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#164193"
    },
    d: "M63.6,10.5l0-4.6C59.4,6,58,8,57.3,9.2V6.7l-4.8,0v10.2V28l4.9,0c0-6.6,0-6.5,0-10.5 C57.5,12.6,60.3,10.7,63.6,10.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#164193"
    },
    points: "19.6,19.4 5,2.3 0,2.3 0,28 5.1,28 5.1,10.8 19.9,28 24.5,28 24.5,2.3 19.6,2.3  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#164193"
    },
    d: "M86.5,0h-4.6v8.4c-1.1-1.4-4.5-2.6-7.4-2.3c-5.5,0.4-9.9,4.9-10.3,10.4c-0.4,6.5,4.7,11.9,11.1,11.9 c2.4,0,5.7-1.1,6.8-3.2l0,2.8h4.3V17.4c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2V0z M81.8,17.5c-0.2,3.7-3.4,6.5-7.2,6 c-2.9-0.4-5.2-2.7-5.6-5.6c-0.4-3.9,2.6-7.2,6.4-7.2c3.4,0,6.2,2.7,6.4,6.1V17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#164193"
    },
    d: "M38.5,6c-6.2,0-11.2,5-11.2,11.2c0,6.2,5,11.2,11.2,11.2s11.2-5,11.2-11.2C49.7,11,44.7,6,38.5,6z M38.5,23.6 c-3.5,0-6.4-2.9-6.4-6.4c0-3.5,2.9-6.4,6.4-6.4s6.4,2.9,6.4,6.4C44.9,20.7,42.1,23.6,38.5,23.6z"
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#164193"
    },
    x1: 94.2,
    y1: 16.8,
    x2: 94.2,
    y2: 16.8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#164193"
    },
    x1: 106.3,
    y1: 13.4,
    x2: 106.3,
    y2: 13.4
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNordea);
export default __webpack_public_path__ + "static/media/nordea.996b3675e5e679b3351d39628a82ec92.svg";
export { ForwardRef as ReactComponent };